




















































































import {
  BookingSlot,
  DisciplineListItemDTO,
  ResourceListItemDTO,
  SubscriptionOfContactDTO,
} from '@bookings/interfaces/online-bookings';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-booking-data-confirmation-modal',
  components: {},
})
export default class BookingDataConfirmationModal extends Vue {
  @Prop(Boolean) readonly value: boolean;
  @Prop(Object) readonly discipline: DisciplineListItemDTO;
  @Prop(Object) readonly resource: ResourceListItemDTO;
  @Prop(Object) readonly bookingSlot: BookingSlot;
  @Prop(Array) readonly subscriptionsOfContact: SubscriptionOfContactDTO[];

  showModal = false;
  selectedSubscription: SubscriptionOfContactDTO = null;
  selectedPaymentMethod = null;

  get model(): boolean {
    return this.value;
  }

  set model(value: boolean) {
    if (value) {
      // Everytime the modal is open, reset the selectedPaymentMethod
      this.selectedPaymentMethod = null;
    }
    this.$emit('input', value);
  }

  get subscriptionsOfDisciplineOrResource(): SubscriptionOfContactDTO[] {
    if (this.discipline?.id) {
      const selectedDisciplineId = this.discipline?.id;
      const selectedResourceId = this.resource?.id;
      return (this.subscriptionsOfContact || []).filter(subscription => {
        if (subscription.disciplines.length === 0 && subscription.resources.length !== 0) {
          const res = subscription.resources.includes(selectedResourceId);
          return res;
        }
        return subscription.disciplines.includes(selectedDisciplineId);
      });
    }
    return this.subscriptionsOfContact;
  }

  get validSubscriptions(): SubscriptionOfContactDTO[] {
    return this.subscriptionsOfDisciplineOrResource
      .filter(subscription => {
        return this.resource.subscriptionsAllowedToPay.includes(subscription.subscription_id);
      })
      .sort((a, b) => a.subscription_id - b.subscription_id);
  }

  get payWithSubscriptionAllowed(): boolean {
    return this.resource?.payWithSubscriptionAllowed;
  }
  get payWithOnlinePaymentAllowed(): boolean {
    return this.resource?.payWithOnlinePaymentAllowed;
  }

  mounted() {
    this.selectedPaymentMethod = null;
  }

  checkIfSubscriptionIsDisabled(subscription: SubscriptionOfContactDTO) {
    return !this.validSubscriptions.some(
      validSubscription => validSubscription.subscription_id === subscription.subscription_id,
    );
  }

  getSubscriptionDisabledReasons(subscription: SubscriptionOfContactDTO) {
    const sPaymentCriteria = this.resource.subscriptionPaymentCriteria;
    console.log('sPaymentCriteria', sPaymentCriteria);
    // Special cases
    if (
      !sPaymentCriteria.resourceOrDisciplineRelatedSubscriptions.includes(
        subscription.subscription_id,
      )
    ) {
      return [
        this.$t(
          'bookings.online_booking.payment_method_not_allowed.resource_or_discipline_related_subscriptions',
        ) as string,
      ];
    }
    if (!sPaymentCriteria.subscriptionPaymentEnabled.includes(subscription.subscription_id)) {
      return [
        this.$t(
          'bookings.online_booking.payment_method_not_allowed.subscription_payment_enabled',
        ) as string,
      ];
    }
    const result = Object.keys(sPaymentCriteria).reduce((res, key) => {
      if (!sPaymentCriteria[key].includes(subscription.subscription_id)) {
        let message = null;
        switch (key) {
          case 'priceCategoryRelatedSubscriptions':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.price_category_related_subscriptions',
            ) as string;
            break;
          case 'resourceOrDisciplineRelatedSubscriptions':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.subscription_payment_enabled',
            ) as string;
            break;
          case 'durationAllowsSubscription':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.duration_allows_subscription',
            ) as string;
            break;
          case 'sufficientCreditsSubscription':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.sufficient_credits_subscription',
            ) as string;
            break;
          case 'minTimeBeforeBookingAllowsSubscription':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.min_time_before_booking_allows_subscription',
            ) as string;
            break;
          case 'maxTimeBeforeBookingAllowsSubscription':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.max_time_before_booking_allows_subscription',
            ) as string;
            break;
          case 'minTimeBetweenTwoBookingsAllowsSubscription':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.min_time_between_two_bookings_allows_subscription',
            ) as string;
            break;
          case 'maxNumberOfOngoingUpcomingBookingsSubscription':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.max_number_of_ongoing_upcoming_bookings_subscription',
            ) as string;
            break;
        }
        if (message) {
          res.push(message);
        }
      }
      return res;
    }, []);
    if (!result.length) {
      return [
        this.$t(
          'bookings.online_booking.payment_method_not_allowed.generic_subscription_message',
        ) as string,
      ];
    }
  }

  get paymentMethodOptions() {
    const subscriptions = this.subscriptionsOfDisciplineOrResource
      .map(subscription => {
        const disabled = this.checkIfSubscriptionIsDisabled(subscription);
        const disabledReasons = !disabled ? [] : this.getSubscriptionDisabledReasons(subscription);
        return {
          text: `${subscription.subscription_category_name}`,

          subtitle: `(${subscription.subscription_code}) [${subscription.credits} ${this.$t(
            'bookings.subscription.credits',
          )}]`,

          id: subscription.subscription_id,
          value: subscription,
          type: 'subscription_payment',
          disabled: disabled,
          disabledReasons: disabledReasons,
        };
      })
      .sort((a, b) => {
        // Sort showing not disabled subscriptions first
        if (a.disabled && !b.disabled) {
          return 1;
        } else if (!a.disabled && b.disabled) {
          return -1;
        }
        return 0;
      });
    const res = [
      {
        text: this.$t('bookings.online_booking.payment_method.online_payment'),
        subtitle: null,
        id: 'online',
        value: {
          subscription_id: null,
          subscription_category_id: null,
          subscription_category_name: null,
          subscription_category_code: null,
          disciplines: null,
          resources: null,
          booking_config: null,
        },
        type: 'online_payment',
        disabled: !this.payWithOnlinePaymentAllowed,
        disabledReasons: this.payWithOnlinePaymentAllowed ? [] : this.onlinePaymentDisabledReasons,
      },
      ...subscriptions,
    ];
    if (res.length > 0 && !res[0].disabled) {
      this.selectedPaymentMethod = res[0].value;
    } else if (res.length > 1 && !res[1].disabled) {
      this.selectedPaymentMethod = res[1].value;
    }
    return res;
  }
  get onlinePaymentDisabledReasons() {
    const oPaymentCriteria = this.resource.onlinePaymentCriteria;
    const result = Object.keys(oPaymentCriteria).reduce((res, key) => {
      if (!oPaymentCriteria[key]) {
        let message = null;
        switch (key) {
          case 'onlinePaymentEnabled':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.online_payment_enabled',
            ) as string;
            break;
          case 'durationAllowsOnlinePayment':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.duration_allows_online_payment',
            ) as string;
            break;
          case 'minTimeBeforeBookingAllowsOnlinePayment':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.min_time_before_booking_allows_online_payment',
            ) as string;
            break;
          case 'maxTimeBeforeBookingAllowsOnlinePayment':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.max_time_before_booking_allows_online_payment',
            ) as string;
            break;
          case 'minTimeBetweenTwoBookingsAllowsOnlinePayment':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.min_time_between_two_bookings_allows_online_payment',
            ) as string;
            break;
          case 'maxNumberOfOngoingUpcomingBookingsOnlinePayment':
            message = this.$t(
              'bookings.online_booking.payment_method_not_allowed.max_number_of_ongoing_upcoming_bookings_online_payment',
            ) as string;
            break;
        }
        if (message) {
          res.push(message);
        }
      }
      return res;
    }, []);

    if (!result.length) {
      return [
        this.$t(
          'bookings.online_booking.payment_method_not_allowed.generic_online_payment_message',
        ) as string,
      ];
    }
    return result;
  }

  @Watch('validSubscriptions', { deep: true })
  onValidSubscriptionsChange() {
    this.selectedPaymentMethod = null;
    if (this.validSubscriptions.length >= 1) {
      this.selectedPaymentMethod = this.validSubscriptions[0];
    }
  }
  @Watch('selectedPaymentMethod', { deep: true })
  onSelectedPaymentMethodChange() {
    this.$emit('selected-payment-method-changed', this.selectedPaymentMethod);
  }
}
